// extracted by mini-css-extract-plugin
export var locationCard = "_ek-0";